<template>
  <section class="risk-catch">
    <div class="risk-catch__inner">
      <p class="risk-catch__text">
        現在<span>最も気になるリスク</span>を<br
          class="u-for-sp"
        />選んでください
      </p>
    </div>
  </section>
  <section class="risk-select">
    <div class="l-app-inner">
      <nav class="p-risk">
        <ul class="p-risk__list">
          <template v-for="button in buttons(current)" :key="button.NUM">
            <RiskNavBtn
              :category="button.CATEGORY"
              :here="button.HERE"
              :image="button.IMAGE"
              :sub="button.SUB"
              :pict="button.PICT"
              :label="button.LABEL"
              :next="button.NEXT"
              @update-condition="setCurrent($event)"
            />
          </template>
        </ul>
      </nav>
    </div>
  </section>
  <section class="l-backhome">
    <a @click="clickBack()" class="c-btn c-btn--backhome">{{ backText }}</a>
  </section>
</template>

<script>
import { RISK_BUTTONS } from "@/const.js";
import RiskNavBtn from "./RiskNavBtn.vue";
export default {
  name: "RiskNav",
  components: {
    RiskNavBtn,
  },
  props: {},
  data() {
    return {
      current: "main",
    };
  },
  computed: {
    buttons() {
      return (id) => {
        return RISK_BUTTONS.find((o) => o.ID === id).BUTTONS;
      };
    },
    backText() {
      return this.current === "main" ? "TOPに戻る" : "リスクと保険に戻る";
    },
  },
  methods: {
    setCurrent(next) {
      this.current = next;
    },
    clickBack(){
      if (this.current === "main") {
        window.location.href = "/";
      } else {
        this.current = "main";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.l-backhome {
  display: flex;
  justify-content: center;
  align-items: center;
  @include pc {
    height: 145px;
  }
  @include sp {
    height: 100px;
  }
}
.p-risk {
  @include pc {
    padding: 65px 0;
  }
  @include sp {
    padding: 40px 20px;
  }
  &__list {
    display: flex;
    justify-content: space-between;
    @include sp {
      flex-wrap: wrap;
      gap: 18px 0;
    }
  }
  &__item {
    @include sp {
      width: calc((100% - 18px) / 2);
      aspect-ratio: 1;
    }
  }
  &__btn {
    display: flex;
    flex-flow: column;
    justify-content: flex-end;
    align-items: center;
    background-color: #fff;
    border: 4px solid #000;
    border-radius: 7px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    @include pc {
      width: 175px;
      height: 175px;
      padding: 15px;
    }
    @include sp {
      width: 100%;
      height: 100%;
      padding: 14px;
    }
    &.--on {
      box-shadow: none;
    }
    .--life & {
      border-color: $color-risk-life;
      color: $color-risk-life;
    }
    .--health & {
      border-color: $color-risk-health;
      color: $color-risk-health;
    }
    .--estate & {
      border-color: $color-risk-estate;
      color: $color-risk-estate;
    }
    .--car & {
      border-color: $color-risk-car;
      color: $color-risk-car;
    }
    &--sub {
      justify-content: center;
      border: 0;
      .--life & {
        background-color: $color-risk-life-light;
        color: $color-risk-life-dark;
      }
      .--health & {
        background-color: $color-risk-health-light;
        color: $color-risk-health-dark;
      }
      .--estate & {
        background-color: $color-risk-estate-light;
        color: $color-risk-estate-dark;
      }
      .--car & {
        background-color: $color-risk-car-light;
        color: $color-risk-car-dark;
      }
    }
    &__upper {
      display: flex;
      align-items: center;
      @include pc {
        height: 85px;
      }
    }
    &__text {
      font-weight: 800;
      @include pc {
        @include font-size(17px);
      }
      @include sp {
        @include font-size(16px);
      }
      span {
        @include pc {
          @include font-size(30px);
        }
        @include sp {
          @include font-size(28px);
        }
      }
    }
    &__title {
      font-weight: 800;
      text-align: center;
      @include sp {
        @include font-size(15px);
      }
    }
  }
  &__alt-btn {
    @include pc {
      max-width: 175px;
      max-height: 175px;
    }
    @include sp {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>